const Builder = require('../BuilderBase');
const DateTimeColumn = require('./DateTimeColumn');
const ForeignRelationTextColumn = require('./ForeignRelationTextColumn');
const LocalVerboseDateTimeColumn = require('./LocalVerboseDateTimeColumn');
const MappedBooleanColumn = require('./MappedBooleanColumn');
const TextColumn = require('./TextColumn');
const filters = require('../filters');

module.exports = class NestedDetail extends Builder {
    constructor(title, properties) {
        super('listColumn_NestedDetail', title, properties);
    }

    dateTime(title, properties) {
        const dateTimeColumn = new DateTimeColumn(title, properties);
        this.addChildBlock(dateTimeColumn, 'nestedColumnField');
        return dateTimeColumn;
    }

    foreignRelationText(title, properties) {
        const foreignRelationTextColumn = new ForeignRelationTextColumn(title, properties);
        this.addChildBlock(foreignRelationTextColumn, 'nestedColumnField');
        return foreignRelationTextColumn;
    }

    localVerboseDateTime(title, properties) {
        const localVerboseDateTimeColumn = new LocalVerboseDateTimeColumn(title, properties);
        this.addChildBlock(localVerboseDateTimeColumn, 'nestedColumnField');
        return localVerboseDateTimeColumn;
    }

    mappedBoolean(title, properties) {
        const mappedBooleanColumn = new MappedBooleanColumn(title, properties);
        this.addChildBlock(mappedBooleanColumn, 'nestedColumnField');
        return mappedBooleanColumn;
    }

    text(title, properties) {
        const textColumn = new TextColumn(title, properties);
        this.addChildBlock(textColumn, 'nestedColumnField');
        return textColumn;
    }

    filter(type, properties) {
        const Filter = filters[type];
        const filter = new Filter(properties);
        this.addChildBlock(filter, 'filters');
        return filter;
    }
};
